exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.toggle_margin {\n  margin-left: 12px;\n}\n.help_icon {\n  color: #000000;\n  opacity: 100%;\n}\n.pickup_message {\n  width: 70%;\n  margin: 0 auto;\n}\n", ""]);

